import {SET_SIDEBAR_CHILDITEMS_EXPANDED, SET_SIDEBAR_EXTENDED} from "store/mapXActionTypes";

export function setSideBarExtended(payload) {
	return {type: SET_SIDEBAR_EXTENDED, payload};
}

export function setSideBarChildItemsExpanded(payload) {
	return {type: SET_SIDEBAR_CHILDITEMS_EXPANDED, payload};
}
